import api from './api';

const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;

const getNewsList = async (
  {
    category = '',
    page = 0,
    size,
  }: {
    category?: string;
    page?: number;
    size: number;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `content/v1/news/national?content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getNewsDetail = (slug: string | number | boolean) =>
  api.get(`content/v1/news/slug/${encodeURIComponent(slug)}`, {}, false, false, false);

const getListFaq = () => api.get(`content/v1/faq?type=CONTENT&code=${2}`, {}, false, false, false);

const getListFaqByBranch = (branch: string | number | boolean) =>
  api.get(
    `content/v1/faq?type=CONTENT&code=${2}&branch=${encodeURIComponent(branch)}`,
    {},
    false,
    false,
    false
  );

const getNewsListByCategory = ({
  category,
  page = 0,
  size,
}: {
  category: string;
  page?: number;
  size: number;
}) => {
  return api.get(
    `content/v1/news?content-category=${encodeURIComponent(category)}&page=${page}&size=${size}`,
    {},
    false,
    false,
    false
  );
};

const getAnotherNews = () => {
  const size = 4;
  return api.get(`content/v1/news?page=${0}&size=${size}`, {}, false, false, false);
};

const getTipsTrik = () => {
  return api.get(
    `content/v1/news?content-category=TIPS%20DAN%20TRIK&page=${0}&size=${4}`,
    {},
    false,
    false,
    false
  );
};

const getNewsListByCity = async (
  {
    city,
    page = 0,
    size = 4,
    category = '',
    isLandingPage = '',
  }: {
    city: string;
    size?: number;
    page?: number;
    category?: string;
    isLandingPage?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `content/v1/news?city=${city}&content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getNewsListByBranch = async (
  {
    category = '',
    page = 0,
    size = 4,
    branch = '',
    isLandingPage = '',
  }: {
    category?: string;
    page?: number;
    size?: number;
    branch?: string;
    isLandingPage?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `content/v1/news?content-category=${encodeURIComponent(
      category
    )}&page=${page}&size=${size}&branchSlug=${encodeURIComponent(
      branch
    )}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getNewsListByProductCode = (
  {
    productCode = '',
    page = 0,
    size = 4,
    type = '',
  }: {
    productCode?: string;
    page?: number;
    size?: number;
    type?: string;
  },
  isUseGatewayAPI?: boolean
) => {
  return api.get(
    `content/v1/news?productCode=${encodeURIComponent(productCode)}&page=${page}&size=${size}&type=${type}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getNewsHero = (
  payload: string[][] | Record<string, string> | string | URLSearchParams,
  isUseGatewayAPI?: boolean
) => {
  const params = new URLSearchParams(payload).toString();
  return api.get(
    `content/v2/news/hero${params ? `?${params}` : ''}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

export default {
  getNewsList,
  getNewsDetail,
  getListFaq,
  getNewsListByCategory,
  getAnotherNews,
  getTipsTrik,
  getNewsListByCity,
  getNewsListByBranch,
  getListFaqByBranch,
  getNewsListByProductCode,
  getNewsHero,
};
